module.exports = __webpack_public_path__ + "img/folder.ef55b947.svg";